import script from "./ButtonLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonLink.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonLink.vue?vue&type=style&index=0&id=580909d8&lang=scss"

const __exports__ = script;

export default __exports__